import React from "react";
import getClassNameFactory from "../../utilities/classNames";

var HorizontalRule = function HorizontalRule() {
  var getClassName = getClassNameFactory(HorizontalRule.displayName);
  return /*#__PURE__*/React.createElement("hr", {
    className: getClassName(),
    "aria-hidden": "true"
  });
};

HorizontalRule.displayName = "HorizontalRule";
export default HorizontalRule;